export const CRHeaderElements = [
  { label: "Fecha", value: "fechaCreacion", align: "inherit" },
  { label: "Titular", value: "titular", align: "inherit" },
  { label: "N° Cuenta", value: "cuenta", align: "inherit" },
  { label: "Sucursal", value: "sucursalNombre", align: "inherit" },
  { label: "Monto", value: "monto", align: "inherit" },
  { label: "Solicitante", value: "usuarioCrea", align: "inherit" },
  { label: "Control", value: "control", align: "center" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];
